module.exports = __webpack_public_path__ + "static/img/howtouse.b9a89f1c.png";